export default __webpack_public_path__ + "static/whats-button-16c113eb44f3222036805c26ce6f9695.svg";